import {
    FLIPPING_FLYER_TYPE,
    LANGUAGE_HEBREW,
    FLYER_STATUS_IN_EDIT, LANGUAGE_ENGLISH,
} from "../globals";

import * as Globals from "../globals";
import {ReactComponentElement} from "react";
import * as React from "react";

export interface RegisterDto {
    firstName?: string;
    lastName?: string;
    fullName?: string;
    phoneNumber?: string;
    company: string;
    emailAddress: string;
    // userName: string;
    password: string;
    accountTier: number;
}

export interface ResetPasswordDto {
    userId: number;
    token: string;
    password: string;
}

export interface LoginDto {
    emailAddress: string;
    password: string;
}

export interface ForgotPasswordDto {
    emailAddress: string;
}

export interface UserDto {
    userId: number;
    token: string;
    accountTier?: number;
    firstName?: string;
    lastName?: string;
    company?: string;
    emailAddress?: string;
    role?: number;
    // userName?: string;
}

export interface FileDto {
    label: string | null;
    file: File | null;
}

export class FlyersDto {
    archivedFlyersCount?: number;
    softDeletedFlyersCount?: number;
    flyers?: FlyerDto[];
    flyerTypes?: FlyerTypeDto[];
    languageCultures?: FlyerLanguageDto[];
    accountSetting?: AccountSettingDto;
    languageId?: number;
    analyticsDashboardUrl?: string;
}

export class FlyerDto {
    flyRecId?: number;
    flyAccRecId?: number;
    flyAcuRecId?: number;
    flyFlsRecId?: number;
    flygusRecId?: number;
    flyLacRecId?: number;
    flyFltRecId?: number;
    flyCode?: string;
    flyGuid?: string;
    flyCaption?: string;
    flyValidFromUtc?: Date;
    flyValidToUtc?: Date;
    flyDisplayCaption?: string;
    flyDesc?: string;
    flyCreatedUtc?: Date;
    flyModifiedUtc?: Date;
    // flyConversionEmail?: string;

    flyImage?: string;
    flyImageUrl?: string;

    flyAccRec?: Account = new Account();

    flyerPages?: FlyerPageDto[] = [];
    deletedFlyerPages?: FlyerPageDto[] = [];

    flyGusRec?: GuiSettingsDto = new GuiSettingsDto();

    flyLacRec?: LanguageCulture = LANGUAGE_HEBREW;
    flyFltRec?: FlyerType = FLIPPING_FLYER_TYPE;

    flyFstRecId?: number = FLYER_STATUS_IN_EDIT.fstRecId!;
    flyFstRec?: FlyerStatus = FLYER_STATUS_IN_EDIT;
    noPages?: number;

    flySpotExcelFileName?: string;
    flyPromoExcelFileName?: string;
    flyPromoItemExcelFileName?: string;
    flyerPromoItems?: any;
    flyerPromos?: any;
    index?: number;
    flyFlyerClassId?: number | null;
    contactDetails?: EmailsObjectDto
    // flyerSetting?: null | CheckoutSettingDto;

    // public virtual Account flyAccRec { get; set; }
    // public virtual AccountUser flyAcuRec { get; set; }
    // public virtual flyerStatus flyFlsRec { get; set; }
    // public virtual flyerType flyFltRec { get; set; }
    // public virtual GuiSetting flyGusRec { get; set; }
    // public virtual LanguageCulture flyLacRec { get; set; }
    // public virtual ICollection<flyerPage> flyerPages { get; set; }
}

export class Account {
    accRecId?: number;
    accXcAccRecId?: string;
    accGuid?: string;
    accCode?: string;
    accCaption?: string;
    accSettings?: string;
    accountSetting?: null | AccountSettingDto;
}

export interface AccountSettingDto {
    conversion?: null | ConversionDto;
    id?: null | number;
    supportedFeatures?: null | SupportedFeatureDto;
    disclaimers?: null | DisclaimerDto;
    uiTexts?: null | UITextDto;
    accountId?: number;
    urls?: null | URLSDto;
}

export interface SupportedFeatureDto {
    isStore: boolean;
}

export interface URLSDto {
    accountHomePageUrl?: string | null
}

// export interface CheckoutSettingDto {
//   conversionUrl?: null | CheckoutUrlSettingDto;
//   id?: number;
//   supportedFeatures?: null | boolean;
//   disclaimer?: null | DisclaimerDto;
//   uiText?: null | UITextDto;
// }

export interface CheckoutUrlSettingStateDto {
    conversionEmail?: string,
    conversionNotificationText?: string;
    conversionPhoneNo?: string;
    conversionPhoneMessage?: string;
    conversionType?: number | null;
    conversionUrlBase?: string;
    conversionUrlBaseApp?: string;
    itemListVarName?: string;
    itemListVarNameApp?: string;
    itemCodePrefix?: string;
    itemCodePrefixApp?: string;
    itemOptionalParamValue?: string;
    itemOptionalParamValueApp?: string;
    optionalVarName?: string;
    optionalVarValue?: string;
    optionalVars?: OptionalVarsDto[];
    optionalVarsApp?: OptionalVarsDto[];
    interItemSeparator?: string;
    interItemSeparatorApp?: string;
    intraItemSeparator?: string;
    intraItemSeparatorApp?: string;
    exampleItemCode1?: string;
    exampleItemQTY1?: string;
    exampleItemCode2?: string;
    exampleItemQTY2?: string;
    isShowAppSetting?: boolean;
    // applyTo?: string;
}

export interface ConversionDto {
    conversionEmail?: null | string;
    conversionNotificationText?: null | string;
    conversionPhoneNo?: null | string;
    conversionPhoneMessage?: null | string;
    conversionType?: number | null;
    conversionUrlBase?: null | string;
    conversionUrlBaseApp?: null | string;
    interItemSeparator?: null | string;
    interItemSeparatorApp?: null | string;
    intraItemSeparator?: null | string;
    intraItemSeparatorApp?: null | string;
    itemCodePrefix?: null | string;
    itemCodePrefixApp?: null | string;
    itemListVarName?: null | string;
    itemListVarNameApp?: null | string;
    itemOptionalParamValue?: null | string;
    itemOptionalParamValueApp?: null | string;
    optionalVars?: null | OptionalVarsDto[];
    optionalVarsApp?: null | OptionalVarsDto[];

}

export interface OptionalVarsDto {
    name?: null | string;
    value?: null | string;
}

export interface DisclaimerDto {
    isFlyerDisclaimer?: null | boolean;
    isListDisclaimer?: null | boolean;
    flyerDisclaimer?: null | string;
    isEnableShowFlyerDisclaimerOnce?: null | boolean;
    listDisclaimer?: null | string;
}

export interface UITextDto {
    goToCheckout?: null | string;
    flyerDisclaimerPopupTitle?: null | string;
    isQuickTips?: null | boolean;
    quickTips?: null | string;
}

// export interface CheckoutUrlSettingDto {
//   conversionUrlBase?: null | string;
//   interItemSeparator?: null | string;
//   intraItemSeparator?: null | string;
//   itemCodePrefix?: null | string;
//   itemListVarName?: null | string;
//   itemOptionalParamValue?: null | string;
//   optionalVarName?: null | string;
//   optionalVarValue?: null | string;
// }


export const flyerDtoInitialState: FlyerDto = {
    flyerPages: [],
    deletedFlyerPages: [],
    flyGusRec: {
        gusPrimaryColorRgb: "#430C79",
        gusFont: Globals.FONT_NAME_ARIAL,
        gusFontSizePt: Globals.FONT_SIZE_1,
    },
    flyLacRec: LANGUAGE_ENGLISH,
    flyFltRec: FLIPPING_FLYER_TYPE,

    flyFstRecId: FLYER_STATUS_IN_EDIT.fstRecId!,
    flyFstRec: FLYER_STATUS_IN_EDIT,

    // flyConversionEmail: "",
};

export class FlyerPageDto {
    flpFlyRecId?: number;
    flpRecId?: number;
    flpflyRecId?: number;
    flpFptRecId?: number;
    flpGuid?: string;
    flpCaption?: string;
    flpDisplayCaption?: string;
    flpPageNo?: number;
    flpImage?: string;
    flpHeightPx?: number;
    flpWidthPx?: number;

    flpImageUrl?: string;
    flyImageThumbnailUrl?: string;

    // flpflyRec
    // flpFptRec
    // flyerPromos
    flyerPageSpots?: FlyerPageSpotDto[] = [];
    qualificationLevel?: number;
    tocEntry?: FlyerTocEntriesDto;
    file?: File;
}

export class PagesDto {
    pages?: string[] = [];
    uiLanguageCultureCode?: string;
}

export class InsertPageDto {
    pageNo?: number;
    uiLanguageCultureCode?: string;
    flyerRecID?: number;
}

export class MovePagesDto {
    pageNo?: number;
    uiLanguageCultureCode?: string;
    flyerPages?: string[] = [];
}

export class UploadImagesToPagesDto {
    FirstPageId?: number;
    Pages!: FlyerPageDto[];
    UiLanguageCultureCode?: string;
    Images: object[] = [];
}

export interface SelectPageForTabsDto {
    pageNo: number;
    selectedTabNum?: number;
}

export interface ImageDataForPage {
    pageId: number,
    imageUrl: string,
    imageThumbnailUrl: string
}

export class GuiSettingsDto {
    gusRecId?: number;
    gusAccRecId?: number;
    gusGuid?: string;
    gusCode?: string;
    gusCaption?: string;
    gusLogo?: string;
    gusPrimaryColorRgb?: string;
    gusBackgroundImage?: string | null;
    gusBackgroundImageUrl?: string | null;
    gusBackgroundColorRgb?: string | null;
    gusSecondaryColorRgb?: string;
    gusFont?: string;
    gusFontSizePt?: number;

    // public virtual Account gusAccRec { get; set; }
    // public virtual ICollection<flyer> flyers { get; set; }

    //
    gusLogoUrl?: string;
    isDeleteable?: boolean = false;
    gusIconContrast?: number = 1;

    logoFile?: FileDto | null;
    backgroundFile?: FileDto | null;
}

export class LanguageCulture {
    lacRecId?: number;
    lacGuid?: string;
    lacCode?: string;
    lacCaption?: string;
    lacDir?: string;
    lacCurrencySymbol?: string;
    lacCurrencyAbbrv?: string;

    // public virtual ICollection<Flyer> Flyers { get; set; }
    // public virtual ICollection<SellingUnitLanguage> SellingUnitLanguages { get; set; }
}

export class CurrencyValues {
    value?: string;
    label?: string;
}

export class FlyerType {
    fltRecId?: number;
    fltGuid?: string;
    fltCode?: number;
    fltCaption?: string;

    // public virtual ICollection<Flyer> Flyers { get; set; }
}

export class FlyerStatus {
    fstRecId?: number;
    fstGuid?: string;
    fstCode?: number;
    fstCaption?: string;
}

export class FlyerPagination {
    value!: string;
    label!: string;
}

export class FlyerStatusForSelect {
    value?: string;
    label?: string;
    status?: FlyerStatus;
}

export interface ErrorDto {
    data?: any;
    elapsedTimeSecs?: number;
    finishTimestampUtc?: string;
    messageID?: number;
    recommendedAction?: string;
    severityLevel?: string;
    startTimestampUtc?: string;
    technicalMessage?: string;
    title?: string;
    userFriendlyMessage?: string;
    id?: number;
    signature?: string;
    siagnostics?: DataItem[];
    languageCultureMessageResponseDto?: LanguageCultureMessageResponseDto;
    diagnostics?: DiagnosticItem[];
}

export interface SuccessDto {
    severityLevel: string;
    userFriendlyMessage: string;
}

export class ErrorsDto {
    status?: number;
    message?: string = "";
    errors?: ErrorDto[] = [];
}

export interface DataItem {
    id?: number;
    name?: string;
    value?: string;
}

export interface LanguageCultureMessageResponseDto {
    title?: string;
    userFriendlyMessage?: string;
    recommendedAction?: string;
}

export interface DiagnosticItem {
    key?: string;
    value?: string;
}

// export interface ErrorDto {
//     status?: number;
//     message?: string;
//     errors?: string[];
// }

export class ErrorDtoFactory {
    public static createErrorDto(err: any): ErrorDto {
        let errorDto: ErrorDto;
        let status: number;
        let message: string;

        if (!err.response) {
            // client error

            message = err.message;

            errorDto = {
                languageCultureMessageResponseDto: {
                    title: message,
                },
            };
        } else {
            status = err.response.status;
            if (status >= 400 && status < 500 ) {
                message = err.message;

                errorDto = {};

                if (err.response.data) {
                    errorDto = {...err.response.data.data};
                    return errorDto;
                }

                if (!errorDto.languageCultureMessageResponseDto) {
                    errorDto.languageCultureMessageResponseDto = {
                        title: message,
                    };
                    return errorDto;
                }
            } else {
                errorDto = {...err.response.data};
            }
        }

        return errorDto;
    }
}

export class FlyerPageSpotDto {
    fpsRecId?: number;
    fpsFlpRecId?: number;
    fpsCode?: number;

    fpsGuid?: string;
    fpsPositionNo?: number;
    fpsCaption?: string;

    fpsDisplayCaption?: string;
    fpsX0px?: number;
    fpsY0px?: number;
    fpsHeightPx?: number;
    fpsWidthPx?: number;
    fpsRotationDeg?: number;

    //
    isForDeletion?: boolean = false;
    hasNumber?: boolean = false;
    flyerPromos?: PromoDto[];
    fpsImage?: string;
    fpsJumpToPageId?: null | number;
    fpsLandingPageUrl?: null | string;
    fpsFrameLink?: null | string;
    fpsFrameLinkApp?: null | string;
    fpsFrameType?: null | number;
    fpsIconXPct?: null | number;
    fpsIconYPct?: null | number;
    fpsTocEntry?: null | FrameTOCDto;
    fpsTooltip?: null | string;
    qualificationLevel?: null | number;
    isLastSelected?: boolean;
}

export interface FrameTOCDto {
    accountId?: number | null;
    caption?: string | null;
    id?: number | null;
    level?: number | null;
    orderInParent?: number | null;
    parentTocEntryId?: number | null;
}

export interface FramesQualificationResponseDto {
    frames: FlyerPageSpotDto[],
    warnings: string[] | null
}

export interface FlyerFrameSettingDto {
    fpsJumpToPageId?: null | number;
    fpsLandingPageUrl?: null | string;
    fpsFrameLink?: null | string;
    fpsFrameType?: null | number;
    fpsIconXPct?: null | number;
    fpsIconYPct?: null | number;
    fpsTocEntry?: null | FrameTOCDto;
    fpsTooltip?: null | string;
    fpsFrameLinkApp?: null | string;
    qualificationLevel?: null | number;
    hasNumber?: boolean;

    [index: string]: any
}

export interface PromoDto {
    flrBuyQty?: number;
    flrCaption?: string;
    flrCode?: string;
    flrDisplayCaption1?: string;
    flrDisplayCaption2?: string;
    flrDisplayCaption3?: string;
    flrFpsRecId?: number;
    flrGuid?: string;
    flrIsQualified?: boolean;
    flrRecId?: number;
    flrRegularPrice?: number;
    flrSalePrice?: number;
    flrSatRecId?: number;
    flrSeuRecId?: number; //selling unit
    flyerPromoItems?: PromoItemsDto[];
    qualificationLevel?: number;
    flrKeywords?: string;
    flrSatCode?: number;
    flrGetPctOff?: number | null;
    flrPctAt?: number | null;
    flrBuyAmount?: number | null;
    flrGetAmountOff?: number | null;
    flrValidToUtc?: any;
    flrValidFromUtc?: any;
    flrGetQty?: any;
    flrImage?: string;
    isLastSelected?: boolean;
    imageSelection?: number;
}

export interface PromoItemsDto {
    fpiBackgroundAudio?: null | any;
    fpiBrand?: null | any;
    fpiBrandLogo?: null | any;
    fpiBuyQty?: null | any;
    fpiCaption?: string;
    fpiCode?: string;
    fpiDisplayCaption1?: string;
    fpiDisplayCaption2?: string;
    fpiDisplayCaption3?: string;
    fpiFlrRecId?: number;
    fpiFlyRecId?: null | any;
    fpiGetQty?: null | any;
    fpiGuid?: string;
    fpiImage?: string;
    fpiIsQualified?: boolean;
    fpiKeywords?: string;
    fpiLandingPageUrl?: null | any;
    fpiPreSaleBuyPrice?: null | any;
    fpiRecId?: number;
    fpiRegularPrice?: number | any;
    fpiSalePrice?: null | any;
    fpiSeuRecId?: null | any;
    fpiSku?: string;
    fpiVisualImpairmentAudio?: null | any;
    qualificationLevel?: number;
    index?: number;
    isLastSelected?: boolean;
    fpiDeptName?: string | null;
    fpiIsBenefit?: boolean;
}

export class CreateSpotsRequestDto {
    userId?: number;
    uiLanguageCultureCode?: string;
    flyerPageId?: number;
    spots?: Array<CreateSpotItemRequestDto>;

    public static parseForDB(
        dtos: FlyerPageSpotDto[],
        flyerPageId: number,
        flyerPage: FlyerPageDto,
        cultureCode: string = "en-US"
    ): CreateSpotsRequestDto {
        let userDtoStr = localStorage.getItem("userDto");
        let userDto: UserDto = JSON.parse(userDtoStr!);

        // let prevSpotX = 0;
        // let prevSpotY = 0;
        // let initialXArray: number[] = [];
        // let initialYArray: number[] = [];
        //

        let requestDto: CreateSpotsRequestDto = {
            userId: userDto.userId,
            uiLanguageCultureCode: cultureCode,
            flyerPageId: flyerPageId,
            spots: dtos.map((dto) => {
                let spotItemDto: CreateSpotItemRequestDto = {
                    caption: dto.fpsCaption,
                    positionNo: dto.fpsPositionNo,
                    displayCaption: dto.fpsCaption,
                    widthPX: dto.fpsWidthPx,
                    heightPX: dto.fpsHeightPx,
                    x0PX: dto.fpsX0px,
                    y0PX: dto.fpsY0px,
                    rotationDeg: dto.fpsRotationDeg,
                    iconXPct: dto.fpsIconXPct,
                    iconYPct: dto.fpsIconYPct,
                    frameType: dto.fpsFrameType,
                    frameLink: dto.fpsFrameLink,
                    frameLinkApp: dto.fpsFrameLinkApp,
                    jumpToPageId: dto.fpsJumpToPageId,
                    landingPageUrl: dto.fpsLandingPageUrl,
                    tocTitle: dto.fpsTocEntry?.caption ? dto.fpsTocEntry.caption : null,
                    tooltip: dto.fpsTooltip
                };

                let scaleX = flyerPage.flpWidthPx! / Globals.FLYER_CANVAS_WIDTH;
                let scaleY = flyerPage.flpHeightPx! / Globals.FLYER_CANVAS_HEIGHT;

                const x1 = Math.floor((dto.fpsX0px! + dto.fpsWidthPx!) * scaleX);
                const y1 = Math.floor((dto.fpsY0px! + dto.fpsHeightPx!) * scaleY);
                spotItemDto.x0PX! = Math.round(dto.fpsX0px! * scaleX);
                spotItemDto.y0PX! = Math.round(dto.fpsY0px! * scaleY);
                spotItemDto.widthPX = x1 - spotItemDto.x0PX!;
                spotItemDto.heightPX = y1 - spotItemDto.y0PX!;

                console.log(`
                create spot:
                x: ${spotItemDto.x0PX!}
                y: ${spotItemDto.y0PX!}
                width: ${spotItemDto.widthPX}
                height: ${spotItemDto.heightPX}`);

                // spotItemDto.x0PX! *= scaleX;
                // spotItemDto.y0PX! *= scaleY;
                // spotItemDto.widthPX! *= scaleX;
                // spotItemDto.heightPX! *= scaleY;
                //
                // spotItemDto.widthPX = Math.floor(spotItemDto.widthPX!);
                // spotItemDto.heightPX = Math.floor(spotItemDto.heightPX!);
                // spotItemDto.x0PX = Math.floor(spotItemDto.x0PX!);
                // spotItemDto.y0PX = Math.floor(spotItemDto.y0PX!);
                // console.log(`x1: ${spotItemDto.x0PX!}
                //                 y1: ${spotItemDto.y0PX!}
                //                 width1: ${spotItemDto.widthPX}
                //                 height1: ${spotItemDto.heightPX}`);


                return spotItemDto;
            }),
        };

        return requestDto;
    }
}

export class CreateSpotItemRequestDto {
    positionNo?: number;
    caption?: string;
    displayCaption?: string;
    x0PX?: number;
    y0PX?: number;
    heightPX?: number;
    widthPX?: number;
    rotationDeg?: number;
    jumpToPageId?: null | number;
    landingPageUrl?: null | string;
    frameLink?: null | string;
    frameLinkApp?: null | string;
    frameType?: null | number;
    iconXPct?: null | number;
    iconYPct?: null | number;
    tocTitle?: null | string;
    tooltip?: null | string;
}

export class UpdateSpotsRequestDto {
    userId?: number;
    uiLanguageCultureCode?: string;
    flyerPageId?: number;
    spots?: Array<UpdateSpotItemDto>;

    public static parseForDB(
        dtos: FlyerPageSpotDto[],
        flyerPageDto: FlyerPageDto,
        cultureCode: string = "en-US"
    ): UpdateSpotsRequestDto {
        let userDtoStr = localStorage.getItem("userDto");
        let userDto: UserDto = JSON.parse(userDtoStr!);


        // let prevSpotX = 0;
        // let prevSpotY = 0;
        // let initialXArray: number[] = [];
        // let initialYArray: number[] = [];
        //
        let requestDto: UpdateSpotsRequestDto = {
            userId: userDto.userId,
            uiLanguageCultureCode: cultureCode,
            flyerPageId: flyerPageDto.flpRecId,
            spots: dtos.map((dto) => {
                let spotItemDto: UpdateSpotItemDto = {
                    spotId: dto.fpsRecId,
                    caption: dto.fpsCaption,
                    // for now code represent positiono
                    code: dto.fpsPositionNo,
                    positionNo: dto.fpsPositionNo,
                    displayCaption: dto.fpsCaption,
                    widthPX: dto.fpsWidthPx,
                    heightPX: dto.fpsHeightPx,
                    x0PX: dto.fpsX0px,
                    y0PX: dto.fpsY0px,
                    iconXPct: dto.fpsIconXPct,
                    iconYPct: dto.fpsIconYPct,
                    frameType: dto.fpsFrameType,
                    frameLink: dto.fpsFrameLink,
                    frameLinkApp: dto.fpsFrameLinkApp,
                    jumpToPageId: dto.fpsJumpToPageId,
                    landingPageUrl: dto.fpsLandingPageUrl,
                    tocTitle: dto.fpsTocEntry?.caption ? dto.fpsTocEntry.caption : null,
                    tooltip: dto.fpsTooltip,
                };

                //
                let scaleX = flyerPageDto.flpWidthPx! / Globals.FLYER_CANVAS_WIDTH;
                let scaleY = flyerPageDto.flpHeightPx! / Globals.FLYER_CANVAS_HEIGHT;

                const x1 = Math.floor((dto.fpsX0px! + dto.fpsWidthPx!) * scaleX);
                const y1 = Math.floor((dto.fpsY0px! + dto.fpsHeightPx!) * scaleY);
                spotItemDto.x0PX! = Math.round(dto.fpsX0px! * scaleX);
                spotItemDto.y0PX! = Math.round(dto.fpsY0px! * scaleY);
                spotItemDto.widthPX = x1 - spotItemDto.x0PX!;
                spotItemDto.heightPX = y1 - spotItemDto.y0PX!;

                console.log(`
                update spot:
                x: ${spotItemDto.x0PX!}
                y: ${spotItemDto.y0PX!}
                width: ${spotItemDto.widthPX}
                height: ${spotItemDto.heightPX}`);

                // spotItemDto.x0PX! *= scaleX;
                // spotItemDto.y0PX! *= scaleY;
                // spotItemDto.widthPX! *= scaleX;
                // spotItemDto.heightPX! *= scaleY;
                //
                // spotItemDto.x0PX = Math.floor(spotItemDto.x0PX!);
                // spotItemDto.y0PX = Math.floor(spotItemDto.y0PX!);
                // spotItemDto.widthPX = Math.round(spotItemDto.widthPX!);
                // spotItemDto.heightPX = Math.round(spotItemDto.heightPX!);
                // console.log(`x: ${spotItemDto.x0PX!}
                //                 y: ${spotItemDto.y0PX!}
                //                 width: ${spotItemDto.widthPX}
                //                 height: ${spotItemDto.heightPX}`);

                return spotItemDto;
            }),
        };

        return requestDto;
    }
}

export class UpdateSpotItemDto {
    spotId?: number;
    // for now represent positionNo
    code?: number;
    positionNo?: number;
    caption?: string;
    displayCaption?: string;
    x0PX?: number;
    y0PX?: number;
    heightPX?: number;
    widthPX?: number;
    rotationDeg?: number;
    jumpToPageId?: null | number;
    landingPageUrl?: null | string;
    frameLink?: null | string;
    frameLinkApp?: null | string;
    frameType?: null | number;
    iconXPct?: null | number;
    iconYPct?: null | number;
    tocTitle?: null | string;
    tooltip?: null | string;
}

export class DeleteSpotsRequestDto {
    userId?: number;
    uiLanguageCultureCode?: string;
    spots?: Array<number>;

    public static parseForDB(
        dtos: FlyerPageSpotDto[],
        cultureCode: string = "en-US"
    ): DeleteSpotsRequestDto {
        let userDtoStr = localStorage.getItem("userDto");
        let userDto: UserDto = JSON.parse(userDtoStr!);

        let reuqestDto: DeleteSpotsRequestDto = {
            userId: userDto.userId,
            uiLanguageCultureCode: cultureCode,
            spots: dtos.map((dto) => {
                return dto.fpsRecId!;
            }),
        };

        return reuqestDto;
    }
}

export interface FlyersStateForArchiveAndDeletedFlyersDto {
    archiveCount: number;
    softDeleteCount: number;
    flyersData: FlyerDto[];
    showLoader: boolean;
    activeFlyers: FlyerDto[];
    isOpenPagesTab?: boolean;
    url: string;
    isSoftDelete?: boolean;
    isModalPopup?: boolean;
    lastActivatedFlyer: FlyerDto
}

export interface ItemInMenuDto {
    type: string;
    name: string;
    isDownload: boolean;
    filesFormat: string;
    isMultiply: boolean;
    code: string;
    text?: string;
    icon?: ReactComponentElement<any>;
    tooltip?: string;
}

export interface ItemsListMenuDto {
    setOpen: any;
    prevOpen: any;
    open: boolean;
    anchorRef: any;
    menuList?: ItemInMenuDto[];
}

export interface StoreMenuDto {
    setOpen: any;
    prevOpen: any;
    open: boolean;
    anchorRef: any;
    menuList?: ItemInMenuDto[];
}

export interface HorizontalTabsDto {
    name: string;
}

export interface ScaleDto {
    scaleX: number;
    scaleY: number;
}

export interface DimensionsDto {
    width: number;
    height: number;
    top: number;
    translateY: number;
}

export interface SaleTypeDto {
    astAccRecId?: number;
    benefit?: any;
    displayCaption?: string;
    lacCode?: string;
    requisite?: any;
    satCaption?: string;
    satCode?: number;
    satRecID?: number;
    isAssignedToAccount?: boolean;
    astRecId?: number;
}

export interface StoreShelfStylesDto {
    storeShelfStyles: StoreShelfStyleDto[]
}
export interface StoreShelfStyleDto {
    accountId: null | number;
    caption: null | string;
    colorRgb: null | string;
    id: number;
    textureImage: null | string;
    textureImageUrl: null | string;
}

export interface DefaultSaleTypeDto {
    saleTypeId: number,
    saleTypeData: DefaultSaleTypeDataDto;
}

export interface DefaultSaleTypeDataDto {
    isChangeableRequisite: boolean,
    isChangeableBenefit: boolean,
    nameRequisite: string,
    nameBenefit: string,
    defaultRequisite: number,
    defaultBenefit: number,
    imageSrc: string
}

export interface PopupSettings {
    typeStatus?: number;
    title?: string;
    subTitle?: string;
    messages?: string[];
    modalName?: string;
}

// export interface CheckoutUrlSettingDto {
//   conversionUrlBase?: null | string;
//   itemListVarName?: null | string;
//   itemCodePrefix?: null | string;
//   interItemSeparator?: null | string;
//   itemOptionalParamValue?: null | string;
//   intraItemSeparator?: null | string;
//   optionalVarName?: null | string;
//   optionalVarValue?: null | string;
// }

export interface ExampleCodeAndQtyDto {
    code: string;
    qty: string;
}

export interface FlyerTypeDto {
    caption: string;
    id: number;
    code: number | string;
}

export interface FlyerLanguageDto {
    caption: string;
    captionNative: string;
    code: string;
    currencySymbol: string;
    currencyAbbrv: string;
    dir: string;
    id: number;
}


export interface UpdateSaleTypesObjectDto {
    saleTypeId?: number;
    action?: number;
}

export interface SellingUnitsDto {
    sellingUnits?: SellingUnitDto[];
    sellingUnitsForFlyer?: SellingUnitDto[];
}

export interface SellingUnitDto {
    caption?: string;
    code?: string;
    id?: number;
    languageCaption?: string;
    languageId?: number;
    guiIncrement?: number,
    maxQty?: number,
    value?: string,
    label?: string
    disabled?: boolean;
    languageDisplayCaption?: string;
    languageAbbrv?: string;
}

export interface AccountSettingWithLangDto {
    accountSetting?: AccountSettingDto;
    languageId?: number;
    loading?: boolean;
    error?: null | ErrorDto;
    type?: null | string;

}

export interface AccountSettingWithLangRequestDto {
    languageId?: number;
    disclaimers?: DisclaimerDto,
    uiTexts?: UITextDto;
    urls?: null | URLSDto;
}

export interface AsyncAnalyticsDataDto {
    analyticsData?: AnalyticsDataDto,
    loading?: boolean;
    error?: null | ErrorDto;
    type: null | string;
    loadingExcel?: null | boolean;
}

export interface AnalyticsDataDto {
    todaysImpressions: null | number;
    todaysConversions: null | number;
    totalImpressions: null | number;
    totalConversions: null | number;
}

export interface UploadProgressingImagesDto {
    isOpen?: boolean;
    current: number;
    failCount: number;
    processingFinished: boolean;
    successCount: number;
    total: number;
    titlePopup: string;
    notUploadedImages: NotUploadedImagesDto[] | null;
    severityLevel: string;
    isUploadingFilesToSystem: boolean;
    isUploadingFilesToSystemFinished: boolean
}

export interface NotUploadedImagesDto {
    imageFileName: string;
    message: string;
}

export interface FrameIconDataDto {
    iconXPercentageNumber: number | null,
    iconYPercentageNumber: number | null,
    type: number | null;
}

export interface flipbookEditorUrlDto {
    flyerId: string;
}

export interface IAuthParamsDto {
    projectName: string;
    screenName?: string;
    userId?: string;
    userEmail?: string;
    token?: string;
}

export interface FlyerTocDto {
    pageRuns: PageRunsDto[] | []
    tocEntryDto: FlyerTocEntriesDto
}

export interface PageRunsDto {
    endPageNo: number;
    startPageNo: number;
}

export interface FlyerTocEntriesDto {
    caption: string;
    flyerId: number;
    id: number;
    orderInParent: number;
}

export interface FlyerPagesTocEntriesDto {
    pageRange: PageRunsDto[] | [];
    caption: string;
    flyerId: number;
    id: number;
    orderInParent: number;
}


export interface PopupDataDto {
    isOpen: boolean;
    pageTocCaption: string | null;
    pageRange: PageRunsDto[] | [];
    isNew: boolean;
    tocEntryId: number | null;
}

export interface FlyerWithoutPageImagesDto {
    numberOfPages: string;
    pageWidth: string;
    pageHeight: string;
}

export interface FlyerClassDto {
    id: string;
    accountId: number;
    caption: string;
}

export interface FlyerPagesAfterWMDto {
    pageId: number;
    pageNo: number;
    qualification: number;
}

export interface IconStyleDto {
    iconStyleType: number,
    value: string,
    label: string,
    iconStyleData: IconStyleDataDto

}

export interface IconStyleDataDto {
    promoCompIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    pageCompIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    linkCompIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    videoCompIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    imgCompIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    img360CompIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    promoCompSrc: string;
    pageCompSrc: string;
    linkCompSrc: string;
    videoCompSrc: string;
    imgCompSrc: string;
    img360CompSrc: string;
}

export interface AccountEmailsSettingsDto {
    emails?: EmailsObjectDto;
    loading?: boolean;
    error?: null | ErrorDto;
    type?: null | string;
}

export interface AccountStoreSettingsDto {
    loading: boolean,
    type: string | null,
    error: null | ErrorDto,
    storeSettings: AccountStoreSettingDto[];
}

export interface UsersAndPermissionsDataDto {
    loading: boolean,
    type: string | null,
    error: null | ErrorDto,
    usersAndPermissions: UserAndPermissionDto[];
}

export interface UpdatePasswordDataDto {
    loading: boolean,
    type: string | null,
    error: null | ErrorDto,
}

export interface AccountStoreSettingDto {
    id?: number | null,
    accountId?: number | null,
    languageCultureId?: number | null,
    caption?: string | null,
    logo?: string | null,
    primaryColorRgb?: string | null,
    secondaryColorRgb?: string | null,
    font?: string | null,
    fontSizePt?: number | null,
    iconContrast?: number | null,
    backgroundImage?: string | null,
    backgroundColorRgb?: string | null,
    logoUrl?: string | null,
    backgroundImageUrl?: string | null,
    isDefaultAccountStoreSetting?: boolean | null,
    storeShelfStyleId?: number | null,
    isDisplayPrices?: boolean;
    isDisplayPromos?: boolean;
}

export interface UserAndPermissionDto {
    acuRecId?: number | null;
    acuAccRecId?: number | null;
    acuXcUsrRecId?: string | null;
    acuGuid?: string | null;
    acuFirstName?: string | null;
    acuLastName?: string | null;
    acuEmailAddress?: string | null;
    acuPasswordHash?: string | null;
    acuPasswordSalt?: string | null;
    acuCreatedUtc?: string | null;
    acuModifiedUtc?: string | null;
    acuIsValidated?: true | null;
    acuPassword?: string | null;
    acuRole?: number | null;
}

export interface UserRoleDto {
    value: string;
    label: string;
}

export interface EmailsObjectDto {
    emailAddress1?: string;
    emailAddress2?: string;
    emailAddress3?: string;
    emailAddress4?: string;
}

export interface DefaultSizesDto {
    width: number;
    height: number;
}

export interface FontSelectObjDto {
    value: string;
    label: string;
}

export interface UpdatePasswordDto {
    currentPassword: string,
    newPassword: string
}